import React from "react";
import styles from './ConfirmationModal.module.css';

export const ConfirmationModal = ({message, onConfirm, onCancel}) => {

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h3 className={styles.modalTitle}>Confirm Action</h3>
                <p className={styles.modalMessage}>{message}</p>
                <div className={styles.buttonGroup}>
                    <button
                        onClick={onConfirm}
                        className={styles.confirmButton}
                    >
                        Sure
                    </button>
                    <button
                        onClick={onCancel}
                        className={styles.cancelButton}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}